export default __webpack_public_path__ + "static/card-8-9527c1e06485baaf4079dee522f9d90b.png";